import React from 'react';
import { NotificationModel } from '../../components/AccountNotifications';

export interface INotificationContextAction {
  type: 'ADD' | 'REMOVE';
  payload?: NotificationModel;
}

export function NotificationContextReducer(state: NotificationModel[], action: INotificationContextAction) {
  switch (action.type) {
    case 'ADD':
      return [action.payload, ...state];
    case 'REMOVE':
      return [...state.filter((x) => x.id !== action.payload.id)];
  }
}

const initialState: NotificationModel[] = [];

const NotificationContext = React.createContext<{
  state: typeof initialState;
  dispatch: (action: INotificationContextAction) => void;
}>({
  state: initialState,
  dispatch: () => {},
});

const NotificationContextProvider: React.FC = (props) => {
  let [state, dispatch] = React.useReducer(NotificationContextReducer, [...initialState]);
  let value = { state, dispatch };
  return <NotificationContext.Provider value={value}>{props.children}</NotificationContext.Provider>;
};

const ContextConsumer = NotificationContext.Consumer;

export { NotificationContext, NotificationContextProvider, ContextConsumer };
